export default __webpack_public_path__ + "static/media/Autobet_whitepaper.503132f6.pdf";